import { StaticValues } from '@utils/enums/StaticValues.enum';
import {
  FieldStatus,
  FormConfigurationDTO,
  InsuranceDetailsConfigurationDTO,
} from '@utils/interfaces';
import { InsuranceFormType } from './PatientDetailsInsuranceForm.interface';

export const addNewPolicy = {
  policyUuid: StaticValues.ADD_NEW,
  memberId: StaticValues.ADD_NEW,
  planId: '',
  insuranceName: StaticValues.ADD_NEW,
  insuranceType: '',
  classification: '',
  insuredPartyContact: {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    phoneNumber: {
      completePhoneNumber: '',
      prefix: '',
      phoneNumber: '',
      type: '',
    },
    streetAddress: '',
    city: '',
    zipCode: '',
    state: '',
    country: 'US',
    relationship: '',
  },
};

export const policiesDependenciesFields = [
  'isHolder',
  'firstName',
  'lastName',
  'gender',
  'dateOfBirth',
  'phoneNumber',
  'streetAddress',
  'city',
  'zipCode',
  'state',
  'country',
  'relationship',
];

export const drivenFieldsConversion = (
  formConfigs: FormConfigurationDTO | undefined,
  formType: InsuranceFormType,
) => {
  const isHidden = (status?: FieldStatus) =>
    status === StaticValues.FIELD_STATUS_HIDDEN;
  const isOptional = (status?: FieldStatus) =>
    status === StaticValues.FIELD_STATUS_OPTIONAL;
  const toDriveMap = (details?: InsuranceDetailsConfigurationDTO) => {
    return {
      insuranceId: {
        hidden: isHidden(details?.insuranceId),
        optional: isOptional(details?.insuranceId),
      },
      insuranceMemberId: {
        hidden: isHidden(details?.insuranceMemberId),
        optional: isOptional(details?.insuranceMemberId),
      },
      isHolder: {
        hidden: isHidden(details?.isHolder),
        optional: isOptional(details?.isHolder),
      },
      firstName: {
        hidden: isHidden(details?.firstName),
        optional: isOptional(details?.firstName),
      },
      lastName: {
        hidden: isHidden(details?.lastName),
        optional: isOptional(details?.lastName),
      },
      gender: {
        hidden: isHidden(details?.gender),
        optional: isOptional(details?.gender),
      },
      dateOfBirth: {
        hidden: isHidden(details?.dateOfBirth),
        optional: isOptional(details?.dateOfBirth),
      },
      phone: {
        hidden: isHidden(details?.phone?.number),
        optional: isOptional(details?.phone?.number),
      },
      streetAddress: {
        hidden: isHidden(details?.streetAddress),
        optional: isOptional(details?.streetAddress),
      },
      city: {
        hidden: isHidden(details?.city),
        optional: isOptional(details?.city),
      },
      zipCode: {
        hidden: isHidden(details?.zipCode),
        optional: isOptional(details?.zipCode),
      },
      state: {
        hidden: isHidden(details?.state),
        optional: isOptional(details?.state),
      },
      country: {
        hidden: isHidden(details?.country),
        optional: isOptional(details?.country),
      },
      relationship: {
        hidden: isHidden(details?.relationship),
        optional: isOptional(details?.relationship),
      },
    };
  };

  const map = {
    primaryInsuranceDetails: toDriveMap(
      formConfigs?.patientDetails?.primaryInsuranceDetails,
    ),
    secondaryInsuranceDetails: toDriveMap(
      formConfigs?.patientDetails?.secondaryInsuranceDetails,
    ),
  };
  return map[formType];
};
